import { FC, ReactNode } from 'react';

import { Box, useTheme } from '@mui/material';

import Icon from 'components/Icons/Icon';
import { Tooltip } from 'components/Tooltip';
import { Text } from 'components/UIkit/atoms/Text';
import { TextProps } from 'components/UIkit/atoms/Text/Text';

interface Props {
  children: ReactNode;
  text: string;
  textVarient?: TextProps['variant'];
}

export const InfoText: FC<Props> = ({ children, text, textVarient }) => {
  const { palette } = useTheme();
  return (
    <Box display="flex" alignItems="center" gap={8} mb={20}>
      <Text color="secondary" variant={textVarient}>
        {text}
      </Text>
      <Tooltip label={<Icon.Info display="flex" color={palette.text.secondary} />} maxWidth={342}>
        <Box p={20}>{children}</Box>
      </Tooltip>
    </Box>
  );
};
